import { TileBodyHeader } from 'common/tile/tile-body-header.js';
import { Tile } from 'common/tile/tile.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IModule } from 'redux-state/layout/types.js';
import { IColumnLayout, IModuleConfig } from 'redux-state/layout/types.modules.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { ILocationWarningType, IWarning, IWeatherWarningsState } from 'redux-state/weather-warnings/types.js';
import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { getLoadedLocationWarnings } from 'utilities/weather-warnings/warnings.js';
import { WarningLocationItem } from './location.item.js';

export interface IWarningTableRedux {
  weatherWarnings: IWeatherWarningsState;
  columnLayout: IColumnLayout;
}

export interface IWarningLocationProps {
  iceLocation: string;
  label: string;
}

export interface IWarningTableCore extends IModuleConfig {
  displayEventType: IWarning['eventType'][];
  locations: IWarningLocationProps[];
}

export const WarningTableCore = (props: IModule<IWarningTableCore> & IWarningTableRedux) => {
  const { displayEventType, locations } = props.config;
  const [locWarnings, setLocWarnings] = useState<IWarning[]>([]);
  useEffect(() => {
    const location: ILocationWarningType = { type: 'marine' as MarkerTypeGeneral.Coastal, key: 'all' };
    const warningState = getLoadedLocationWarnings(location, props.weatherWarnings.warnings);
    setLocWarnings(warningState?.warnings ?? []);
  }, [props.weatherWarnings]);

  const filteredWarnings = locWarnings.filter((w) => displayEventType.indexOf(w.eventType) >= 0);
  return (
    <Tile dataModule="warning-table" {...props}>
      <div className="Tile-body">
        <TileBodyHeader {...props} titleDefault="Heavy Swell Warnings" />
        <ul className="LocationList u-mT-xs">
          {locations.map((l) => {
            return <WarningLocationItem key={l.iceLocation} filteredWarnings={filteredWarnings} location={l} />;
          })}
        </ul>
      </div>
    </Tile>
  );
};

export const WarningTableEntry = (props: IModule<IWarningTableCore>) => {
  const weatherWarnings = useSelector((s: IRepoState) => s.WEATHER_WARNINGS);
  const columnLayout = useContext(ColumnLayoutContext);
  return <WarningTableCore weatherWarnings={weatherWarnings} columnLayout={columnLayout} {...props} />;
};
